// extracted by mini-css-extract-plugin
export var textInput = "_cd-0";